<script setup>
import { computed } from 'vue';
import { useRoute } from 'vue-router';
import { useAccount } from 'dashboard/composables/useAccount';

const route = useRoute();
const { accountScopedRoute } = useAccount();

const tabs = [
  { key: 'account_overview_reports', label: 'Visão Geral', icon: 'grid' },
  { key: 'conversation_reports', label: 'Por Categoria', icon: 'calendar' },
  { key: 'agent_reports_index', label: 'Relatório Individual', icon: 'user' },
  { key: 'inbox_reports_index', label: 'Atendimento', icon: 'chat' },
];

const activeTabKey = computed(() => route.name);
</script>

<!-- eslint-disable vue/no-bare-strings-in-template, vue/no-static-inline-styles -->
<template>
  <div class="overflow-auto bg-n-surface-1 w-full px-6">
    <div class="max-w-5xl mx-auto pb-12">
      <div style="padding-top: 24px; margin-bottom: 24px">
        <div class="clara-pill-tabs">
          <router-link
            v-for="tab in tabs"
            :key="tab.key"
            :to="accountScopedRoute(tab.key)"
            class="clara-pill-tab"
            :class="{ active: activeTabKey === tab.key }"
            style="text-decoration: none"
          >
            <svg
              v-if="tab.icon === 'grid'"
              class="tab-icon"
              style="width: 16px; height: 16px"
              fill="none"
              stroke="currentColor"
              stroke-width="2"
              viewBox="0 0 24 24"
            >
              <rect x="3" y="3" width="7" height="7" />
              <rect x="14" y="3" width="7" height="7" />
              <rect x="14" y="14" width="7" height="7" />
              <rect x="3" y="14" width="7" height="7" />
            </svg>
            <svg
              v-else-if="tab.icon === 'calendar'"
              class="tab-icon"
              style="width: 16px; height: 16px"
              fill="none"
              stroke="currentColor"
              stroke-width="2"
              viewBox="0 0 24 24"
            >
              <rect width="18" height="18" x="3" y="4" rx="2" ry="2" />
              <line x1="16" x2="16" y1="2" y2="6" />
              <line x1="8" x2="8" y1="2" y2="6" />
              <line x1="3" x2="21" y1="10" y2="10" />
            </svg>
            <svg
              v-else-if="tab.icon === 'user'"
              class="tab-icon"
              style="width: 16px; height: 16px"
              fill="none"
              stroke="currentColor"
              stroke-width="2"
              viewBox="0 0 24 24"
            >
              <path d="M16 21v-2a4 4 0 0 0-4-4H6a4 4 0 0 0-4 4v2" />
              <circle cx="9" cy="7" r="4" />
            </svg>
            <svg
              v-else-if="tab.icon === 'chat'"
              class="tab-icon"
              style="width: 16px; height: 16px"
              fill="none"
              stroke="currentColor"
              stroke-width="2"
              viewBox="0 0 24 24"
            >
              <path
                d="M21 15a2 2 0 0 1-2 2H7l-4 4V5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2z"
              />
            </svg>
            {{ tab.label }}
          </router-link>
        </div>
      </div>
      <router-view />
    </div>
  </div>
</template>
